import {
    ALL_COMPANIES,
    PARENT_COMPANIES,
    CHILD_COMPANIES,
    RECENT_COMPANIES,
    VST
} from "@legacy/helpers/constants/sharedStatics";

export default {
    ALL_COMPANIES,
    PARENT_COMPANIES,
    CHILD_COMPANIES,
    RECENT_COMPANIES,
    VST
};